import React from "react";
import StyledDropdown from "@/components/common/styled-dropdown";

type Props = {
  datasetLanguage: string;
  changeDatasetLanguage: (value: string) => void;
};

const LanguageDropdown = ({
  datasetLanguage,
  changeDatasetLanguage,
}: Props) => {
  return (
    <StyledDropdown
      values={["English", "Russian", "Korean", "Other"]}
      onChanged={changeDatasetLanguage}
      currentValue={datasetLanguage}
    />
  );
};

export default LanguageDropdown;
